export const processaRegistrosDefaultIniciaisObjConsorcio = ( values ) => {

    if (!values.objConsorcio.simulacao) {

        values.objConsorcio.simulacao = [{}]
    }
}